<template>
  <section class="page-container">
    <div class="flex-sb-center flex-title">
      <span class="title">Private Car Class List</span>
      <span class="flex">
        <span
          v-for="(item,index) in carClasslist"
          :key="index"
          class="blue pointer"
          @click="handleCarClass(item.path)">{{item.name}}</span>
      </span>
    </div>
    <div class="transparent">
      <el-table
        :data="privateCartableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          prop="class"
          label="Car Type">
        </el-table-column>

        <el-table-column
          prop="insurer_count"
          label="Insurer Class">
        </el-table-column>

        <el-table-column
          prop="make_count"
          label="Makes">
        </el-table-column>

        <el-table-column
          prop="model_count"
          label="Models">
        </el-table-column>
      </el-table>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {mapActions, mapState} from 'vuex'
import {getCarClassIndex, getCarClassInit} from '@/api/privateCarList'


export default {
  name: 'TicketReport',
  components:{

  },
  mixins: [MixinOptions],
  props:{

  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      date: '',
      redeemedDate: '',
      privateCartableData: [],
      search:'',
      classId:11
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
  },
  watch: {
    property: {
      immediate: true,
      handler() {

      }
    }
  },
  async mounted() {
    await this.network().getCarClassIndex()
  },
  methods: {
    ...mapActions('quote', ['setIsBack']),
    handleCarClass(path){
      this.$router.push('/private-car-list/'+path)
    },
    rowClick(row) {
      this.$router.push('/private-car-list/manage-make')
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getCarClassIndex()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getCarClassIndex()
    },
    network() {
      return {
        getCarClassIndex: async () => {
          const { data } = await getCarClassIndex({
            // page: this.pageConfig.currentPage,
          })
          let {private_car} = data
          this.privateCartableData = private_car
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;
  .flex-title{
    margin-bottom: 15px;
    .title{
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
      color: $dark;
    }
    .blue{
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      letter-spacing: -0.15px;
      margin-right: 15px;
      margin-left: 15px;
      &:after{
        content: '';
        width: 1px;
        height: 20px;
        position: absolute;
        margin-right: 15px;
        margin-left: 15px;
        background: #D1D5DA;
      }
      &:last-child{
        margin-right: 0;
        &:after{
          position: relative;
        }
      }
    }
  }
  .text-date{
    font-size: 12px;
  }
  .filter-top{
    margin-bottom: 30px;
  }
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  h1 {
    // margin-bottom: 20px;
    font-size: 34px;
  }
  .filter-container {
    .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .search-box {
        margin-right: 20px;
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
    }

  }
  .span-name {
    display: block;
    color: #24292E;
  }
  .span-label {
    display: block;
    color: #24292E;
    font-weight: 500;
  }
  .form-half {
    & > span {
      display: block;
      padding-bottom: 5px;
      font-size: 14px;
      color: #6a737d;
    }
  }
  .filter-card {
    margin-bottom: 30px;
    margin-top: 15px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    .filter-main {
      //display: flex;
      padding: 0 15px;
      .filter-left{
        padding: 15px 0;
        display: flex;
        //justify-content: space-between;
        .form-item{
          margin-right: 30px;
        }
      }
    }
  }
  ::v-deep .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;
    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      color: #24292E!important;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    //line-height: 30px;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }
  .margin-top-flex{
    margin-top: 5px;
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
    }
    .content-pending{
      height: 22px;
      width: 22px;
      margin-right: 10px;
    }
  }
  .el-table{
    ::v-deep .flex-algin{
      display: flex;
      flex-direction: column;
      justify-content:space-between ;
      p{
        height: 24px;
      }
      span{
        font-size: 14px;
        line-height: 20px;
        color: #24292E;
      }
    }
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 500;
    }
  }
  .time{
    font-size: 12px;
    line-height: 18px;
    color: #24292E;
  }
  .blue{
    color: #0366D6;
    cursor: pointer;
  }
}
</style>
